import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    success: ({ name }: {
        name?: string;
    }) => string | React.ReactNode;
    error: ({ name }: {
        name?: string;
    }) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** The title of a toast that is shown when the access to a share is updated successfully */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name?: string;
                    }) => __intl__.intl().formatMessage({ id: "renderShareAccessToast.success?c=2nga8j58yid1a", defaultMessage: "Access to \"{name}\" has been updated" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** The title of a toast that is shown when an error occurs during an attempted update */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name?: string;
                    }) => __intl__.intl().formatMessage({ id: "renderShareAccessToast.error?c=7gd3eg494ln0", defaultMessage: "Failed to update access{name, select, true { for {name}} other {}}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
